import "core-js/fn/promise";
import React from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/browser";
import "./index.css";
import { LicenseManager } from "ag-grid-enterprise";
import "./i18n";
import Root from "./Root";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import theme from "./theme";

Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
});

LicenseManager.setLicenseKey(
    "CompanyName=Avenir Health, Inc.,LicensedGroup=Avenir Health,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=4,LicensedProductionInstancesCount=4,AssetReference=AG-034875,SupportServicesEnd=10_February_2024_[v2]_MTcwNzUyMzIwMDAwMA==ae89b790138d1bfed9f913c2d60bce65"
);

/* NOTE: A way to surpass console errors.  Use at your OWN RISK. */
const error = console.error;
console.error = (...args) => {
    if (/defaultProps/.test(args[0])) return;
    if (/findDOMNode/.test(args[0])) return;
    error(...args);
};

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
    <>
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <Root />
            </ThemeProvider>
        </StyledEngineProvider>
    </>
);
